import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  ACCOUNT_GET,
  PAYMENT_GET,
} from "../apis/Endpoint";
import PaymentChart from "../component/PaymentChart";

const Dashboard = () => {
  const [accountStats, setAccountStats] = useState({
    total: 0,
    active: 0,
    deactive: 0,
  });

  const [transcationStats, setTranscationStats] = useState({
    totaltranscation: 0,
    totalcredit: 0,
    totaldebit: 0,
  });

  const dummyData = [
  { label: 'Jan', amount: 1200 },
  { label: 'Feb', amount: 1300 },
  { label: 'Mar', amount: 1400 },
  { label: 'APR', amount: 1100 },
];

  const weeklyDummyData = [
  { label: 'Week 1', amount: 1200 },
  { label: 'Week 2', amount: 1350 },
  { label: 'Week 3', amount: 1100 },
  { label: 'Week 4', amount: 1500 },
];


  const fetchAccountStats = async () => {
    try {
      const res = await axios.get(ACCOUNT_GET);
      const accounts = res.data.data || [];

      const total = accounts.length;
      const active = accounts.filter((acc) => acc.status === "Active").length;
      const deactive = accounts.filter((acc) => acc.status === "Deactive").length;

      setAccountStats({ total, active, deactive });
    } catch (err) {
      console.error("Error fetching accounts", err);
    }
  };

  const fetchTranscationStats = async () => {
    try {
      const res = await axios.get(PAYMENT_GET);
      const transcation = res.data.data || [];

      const totaltranscation = transcation.length;
      const totalcredit = transcation.filter((pay) => pay.type === "Credit").length;
      const totaldebit = transcation.filter((pay) => pay.type === "Debit").length;

      setTranscationStats({
        totaltranscation,
        totalcredit,
        totaldebit,
      });
    } catch (err) {
      console.error("Error fetching transcations", err);
    }
  };

  useEffect(() => {
    fetchAccountStats();
    fetchTranscationStats();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography variant="h4" gutterBottom>
        DASHBOARD
      </Typography>

      {/* Account Stats */}
      <Box sx={statsContainerStyle}>
        <StatCard title="Total Account" value={accountStats.total} />
        <StatCard title="Active Accounts" value={accountStats.active} />
        <StatCard title="DeActive Accounts" value={accountStats.deactive} />
      </Box>

      {/* Transaction Stats */}
      <Box sx={statsContainerStyle}>
        <StatCard title="Total Transaction" value={transcationStats.totaltranscation} />
        <StatCard title="Total Credit" value={transcationStats.totalcredit} />
        <StatCard title="Total Debit" value={transcationStats.totaldebit} />
      </Box>

      {/* Charts */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-around",
          mt: 4,
        }}
      >
        <Box sx={{ width: "40%",  }}>
          <PaymentChart title="Monthly Payment Chart" data={dummyData} />
        </Box>
        <Box sx={{ width: "40%", minWidth: 300 }}>
          <PaymentChart title="Weekly Payment Chart" data={weeklyDummyData} />
        </Box>
      </Box>
    </Box>
  );
};

// Reusable card
const StatCard = ({ title, value }) => (
  <Paper elevation={3} sx={paperStyle}>
    <Typography variant="body1">{title}</Typography>
    <Typography variant="h6">{value}</Typography>
  </Paper>
);

const statsContainerStyle = {
  width: "100%",
  height: "18vh",
  display: "flex",
  justifyContent: "center",
  gap: 5,
  flexWrap: "wrap",
};

const paperStyle = {
  width: "20%",
  minWidth: "200px",
  height: "15vh",
  fontSize: "20px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  color: "black",
  borderColor: "#7b1fa2",
  borderWidth: 2,
  borderStyle: "solid",
};

export default Dashboard;
